let trim = function(s) {
    if (s != null)
        return s.replace(/^\s+|\s+$/g, '')
    else
        return null
};

export default trim;
